import { render, staticRenderFns } from "./CallStackItem.vue?vue&type=template&id=56a1172a"
import script from "./CallStackItem.vue?vue&type=script&lang=js"
export * from "./CallStackItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports